// frontend/shared-ui/src/icons/TruckDeliveryIcon.jsx
import React from "react";

export default function TruckDeliveryIcon({
  size = 16,
  className = "",
  ...rest
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <path d="M9 20a2 2 0 100-4 2 2 0 000 4z" />
      <path d="M19 20a2 2 0 100-4 2 2 0 000 4z" />
      <path d="M3 6h11v11H3z" />
      <path d="M14 9h4l3 3v5h-7" />
    </svg>
  );
}
